import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\SessionTemplateController::store
* @see app/Http/Controllers/Api/SessionTemplateController.php:29
* @route '/api/session-templates'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/api/session-templates',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\SessionTemplateController::store
* @see app/Http/Controllers/Api/SessionTemplateController.php:29
* @route '/api/session-templates'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\SessionTemplateController::store
* @see app/Http/Controllers/Api/SessionTemplateController.php:29
* @route '/api/session-templates'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\SessionTemplateController::show
* @see app/Http/Controllers/Api/SessionTemplateController.php:18
* @route '/api/session-templates/{sessionTemplate}'
*/
export const show = (args: { sessionTemplate: number | { id: number } } | [sessionTemplate: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/api/session-templates/{sessionTemplate}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\SessionTemplateController::show
* @see app/Http/Controllers/Api/SessionTemplateController.php:18
* @route '/api/session-templates/{sessionTemplate}'
*/
show.url = (args: { sessionTemplate: number | { id: number } } | [sessionTemplate: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { sessionTemplate: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { sessionTemplate: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            sessionTemplate: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        sessionTemplate: typeof args.sessionTemplate === 'object'
        ? args.sessionTemplate.id
        : args.sessionTemplate,
    }

    return show.definition.url
            .replace('{sessionTemplate}', parsedArgs.sessionTemplate.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\SessionTemplateController::show
* @see app/Http/Controllers/Api/SessionTemplateController.php:18
* @route '/api/session-templates/{sessionTemplate}'
*/
show.get = (args: { sessionTemplate: number | { id: number } } | [sessionTemplate: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\SessionTemplateController::show
* @see app/Http/Controllers/Api/SessionTemplateController.php:18
* @route '/api/session-templates/{sessionTemplate}'
*/
show.head = (args: { sessionTemplate: number | { id: number } } | [sessionTemplate: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

const sessionTemplates = {
    store: Object.assign(store, store),
    show: Object.assign(show, show),
}

export default sessionTemplates